module.exports = __webpack_public_path__ + "img/HAB_cahora.f9cc62d4.jpg";